// extracted by mini-css-extract-plugin
module.exports = {"contentGrid":"MigrationPage_contentGrid__20N_H"};